import * as React from 'react';

import type {SelectComponentValue} from 'nutshell-core/types';

import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';
// @ts-expect-error - imported from .js/.jsx file
import {StateSelect} from 'shells/select/state-select';

import type {StateFormValue, SelectedLocationStateFilterType} from './types';

import styles from './location-default.module.css';

type Props = {
    value?: StateFormValue;
    onChange: (formValue: {[field: string]: State}) => void;
    name: string;
};

type State = {
    selected: SelectedLocationStateFilterType;
    data: any;
};

export function FormState(props: Props) {
    const {name, onChange} = props;

    const [selected, setSelected] = React.useState<SelectedLocationStateFilterType>(
        props.value && props.value.selected ? props.value.selected : 'noLocation'
    );
    const [state, setState] = React.useState<string | null | undefined>(
        props.value && props.value.selected === 'exactMatch' && props.value.data
            ? props.value.data.state
            : null
    );

    React.useEffect(() => {
        onChange({
            [name]: {
                selected: selected,
                data:
                    selected === 'noLocation'
                        ? null
                        : {
                              selected: 'state',
                              country: 'US',
                              state: state || '*',
                          },
            },
        });
    }, [selected, state, name, onChange]);

    const handleStateSelectChange = (stateSelectObject: SelectComponentValue) => {
        setState(stateSelectObject.id);
    };

    /**
     * Called when a radio button is selected - we'll updated our state's
     * selected value, and then seed the data of that selected value with
     * our pre-canned defaults
     * @param  {SelectedFilterType} selected – key of selected value
     * @return {void}
     */
    const handleRadioSelect = (newSelection: SelectedLocationStateFilterType) => {
        if (newSelection !== selected) {
            setSelected(newSelection);

            if (newSelection === 'exactMatch') {
                setState('*');
            }
        }
    };

    return (
        <div className={styles.container}>
            {/* @ts-expect-error */}
            <RadioGroup onChange={handleRadioSelect} selectedValue={selected} name={props.name}>
                <Radio value='noLocation'>No location specified</Radio>
                <Radio value='exactMatch'>State</Radio>
                {selected === 'exactMatch' ? (
                    <div className={styles['exact-match-container']}>
                        <StateSelect
                            value={state}
                            country='US'
                            onChange={handleStateSelectChange}
                        />
                    </div>
                ) : null}
            </RadioGroup>
        </div>
    );
}
